/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconEPICPDF = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--epicpdf',
    className,
  )

  return (
    <IconBase className={classes} viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"{...rest}><path className="path1" fillRule="evenodd" clip-rule="evenodd" d="M.01 2C.01.9.9 0 2 0h8l6 6v12c0 1.1-.9 2-2 2H1.99C.89 20 0 19.1 0 18L.01 2zM9 1.5V7h5.5L9 1.5z" fill="#BDBDBD"/><mask mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="20"><path className="path2" fillRule="evenodd" clip-rule="evenodd" d="M.01 2C.01.9.9 0 2 0h8l6 6v12c0 1.1-.9 2-2 2H1.99C.89 20 0 19.1 0 18L.01 2zM9 1.5V7h5.5L9 1.5z" fill="#fff"/></mask><g mask="url(#a)"><path className="path3" fill="#BDBDBD" d="M0 0h16v20H0z"/></g><path className="path4" fillRule="evenodd" clip-rule="evenodd" d="M3.022 13.353h.336c.315 0 .55-.064.706-.193.156-.13.234-.317.234-.563 0-.248-.066-.432-.196-.55-.131-.119-.336-.178-.615-.178h-.465v1.484zm2.308-.793c0 .538-.162.95-.487 1.234-.324.285-.785.428-1.383.428h-.438V16H2v-5h1.54c.584 0 1.029.13 1.333.392.304.26.457.65.457 1.168zm4.909.892c0 .823-.226 1.454-.678 1.891-.452.438-1.104.657-1.957.657H6.24v-5h1.513c.787 0 1.398.216 1.833.646.435.431.652 1.033.652 1.806zm-1.062.027c0-1.073-.457-1.61-1.372-1.61h-.543v3.255H7.7c.985 0 1.477-.548 1.477-1.645zM12.243 16h-1.006v-5H14v.869h-1.757v1.289h1.635v.865h-1.635V16z" fill="#fff"/></IconBase>
  )
}

IconEPICPDF.propTypes = {
  className: PropTypes.string,
}

export default IconEPICPDF
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconEPICPDF.js